// -----------------------------------------------------------
// FloraIQ - Produtos e relatorios previstos do fluxo operacional
// -----------------------------------------------------------
// Lista o que a acao de cadastramento deve entregar. Nao ha geracao nem
// historico real de produtos, entao nao ha status nem datas.

interface PlannedItem {
  id: string;
  titulo: string;
  descricao: string;
  /** Rotulos curtos exibidos abaixo da descricao (tipo, formato, etapa). */
  tags: string[];
}

interface Props {
  title: string;
  description: string;
  items: PlannedItem[];
}

export default function PlannedProductsGrid({ title, description, items }: Props) {
  return (
    <div className="space-y-3">
      <div>
        <h4 className="text-sm font-bold text-foreground-900">{title}</h4>
        <p className="text-xs text-foreground-500 mt-0.5">{description}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((item) => (
          <div key={item.id} className="rounded-lg border border-background-200/70 bg-white p-3">
            <p className="text-xs font-semibold text-foreground-800">{item.titulo}</p>
            <p className="text-[11px] text-foreground-500 mt-1">{item.descricao}</p>
            <div className="flex flex-wrap gap-1 mt-2">
              {item.tags.map((t) => (
                <span key={t} className="text-[10px] px-1.5 py-0.5 rounded bg-background-50 border border-background-200 text-foreground-500">{t}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
